import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1047215034779713';
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    _fbq?: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      if (!window.fbq) {
        // Standard Meta Pixel stub
        const n: any = function () {
          // eslint-disable-next-line prefer-rest-params
          n.callMethod ?
          // eslint-disable-next-line prefer-rest-params
          n.callMethod.apply(n, arguments) :
          // eslint-disable-next-line prefer-rest-params
          n.queue.push(arguments);
        };
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        window.fbq = n;
        if (!window._fbq) window._fbq = n;
        // Inject script tag with onerror handler so a failed load doesn't
        // bubble up as a generic "Script error." on window.
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        script.onerror = () => {
          // Silently ignore — pixel will simply not track in this env.
        };
        const target = document.head || document.body || document.documentElement;
        if (target) target.appendChild(script);
      }
      window.fbq && window.fbq('init', PIXEL_ID);
      window.fbq && window.fbq('track', 'PageView');
    } catch (e) {
      // Never let the pixel break the page.
      // eslint-disable-next-line no-console
      console.warn('MetaPixel init failed:', e);
    }
  }, []);
  return <noscript data-id="element-130" data-mp="216ia5n9149pu">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-131" data-mp="216a0034ajiic" />
    </noscript>;
}
// Helper to track checkout intent from buttons.
// Safe to call even if pixel never initialized.
export function trackInitiateCheckout() {
  try {
    if (typeof window === 'undefined' || !window.fbq) return;
    window.fbq('track', 'InitiateCheckout', {
      value: 19,
      currency: 'USD',
      content_name: 'Funcional 360'
    });
  } catch (e) {
    // Never let analytics crash a checkout click.
    // eslint-disable-next-line no-console
    console.warn('InitiateCheckout track failed:', e);
  }
}